import i18n from '@/utils/i18n';
import React from 'react';
import { AlreadyInOrderAction } from '@/components/already-in-order-action';
import { Button } from '@/components/button';
import {
  ItemListOption,
  ItemListOptionMetadata,
} from '@/contexts/item-context-types';
import { StyleSheet } from 'react-native';

interface Props {
  alreadyInOrder?: boolean;
  onSelect: (itemListOption: ItemListOption) => void;
  sku: ItemListOptionMetadata;
}

export const ChooseSubstitutionButton: React.FC<Props> = ({
  alreadyInOrder = false,
  onSelect,
  sku,
}) => {
  if (alreadyInOrder) {
    return <AlreadyInOrderAction />;
  }

  return (
    <Button
      onPress={() => {
        onSelect({
          metadata: {
            ...sku,
            skus: [sku],
          },
          title: sku.displayName,
          value: sku.variantPackUUID,
        });
      }}
      size="small"
      style={styles.selectButton}
      trackingData={{
        name: 'choose_substitution.select_button',
        properties: {
          variantPackUUID: sku.variantPackUUID,
        },
      }}
    >
      {i18n.t('select')}
    </Button>
  );
};

const styles = StyleSheet.create({
  selectButton: {
    paddingHorizontal: 22,
  },
});
